import React from 'react';

const BeerInfoBox = ({ label, info, textColor }) => (
  <div className='flex justify-start items-center mb-2 '>
    <span className={`font-bold mr-2 text-xl ${textColor}`}>{label}:</span>
    <span className='uppercase text-white text-xl'>{info}</span>
  </div>
);

export default function BeerInfo({ beer }) {
  const {
    title,
    subtitle,
    alcohol,
    titleStyle,
    beerStyle,
    description,
    textColor,
    buttonStyle,
    buttonDisabled,
    link,
  } = beer;

  return (
    <div className='mr-3 pt-2 px-4 pb-4  h-full flex flex-col justify-center'>
      <label
        className='uppercase text-justify text-2xl md:text-2xl  text-center mb-2 bg-clip-text text-white'
        style={{ textShadow: '2px 2px 4px rgba(0, 0, 0, 0.7)' }}
      >
        {subtitle}
      </label>
      <label
        className={`uppercase text-6xl sm:text-6xl md:text-6xl lg:text-8xl font-bold  mb-2 bg-clip-text text-transparent ${titleStyle}`}
        dangerouslySetInnerHTML={{ __html: title }}
      ></label>
      <p
        className='text-left text-white text-xl md:text-2xl leading-relaxed mb-4 tracking-wide slavic-font pt-5'
        dangerouslySetInnerHTML={{ __html: description }}
      />

      <div className='flex space-x-3'>
        <BeerInfoBox label={'STIL'} info={beerStyle} textColor={textColor} />
        <BeerInfoBox label={'ALKOHOL'} info={alcohol} textColor={textColor} />
        <BeerInfoBox label={'IBU'} info={alcohol} textColor={textColor} />
      </div>

      <button
        disabled={buttonDisabled}
        className={`mt-10 uppercase w-full sm:w-[50%] md:w-[30%] lg:w-[30%] text-white text-lg md:text-xl py-2 px-4 rounded-lg tracking-wider ${
          buttonDisabled ? 'border-2 border-gray-500' : buttonStyle
        }`}
        onClick={() => window.open(link, '_blank', 'noopener,noreferrer')}
      >
        {buttonDisabled ? 'Uskoro' : 'Poru^i'}
      </button>
    </div>
  );
}
